import { useContext } from 'react';

import { GeneralDispatchContext, GeneralStateContext } from './Provider';

export const useGeneralDispatch = () =>
  useContext(GeneralDispatchContext);

export const useGeneralState = () =>
  useContext(GeneralStateContext);
